<nz-cascader [nzOptions]="unitTreeNodes" [(ngModel)]="unitCascaderValue" [nzShowSearch]="{ filter }"
	nzPlaceHolder="请选择或者模糊搜索，至少输入2个字符进行匹配。" (nzClear)="onUnitCascaderClear()" [nzSuffixIcon]="disabled ? ' ' : 'down'"
	[nzDisabled]="disabled" (ngModelChange)="onUnitCascaderValueChange()">
</nz-cascader>